export default function getFlexShrink(shrink) {
  return shrink === false ? "shrink-0" : shrink === true ? "shrink" : "";
}
